var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          stripe: false,
          selection: _vm.selection,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    prop: "sourcingStatus",
                    label: _vm.$t("SourcingDetails.form.status"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(
                                    scope.row.sourcingStatus
                                  )
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "skuName",
                    label: _vm.$t("SourcingDetails.form.SKU"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "skuCode",
                    label: _vm.$t("SourcingDetails.form.SKUcode"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "num",
                    label: _vm.$t("SourcingDetails.form.quantity"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "giftFlag",
                    align: "center",
                    label: _vm.$t("SourcingDetails.form.Whether"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: scope.row.giftFlag ? "success" : "info",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.STATUS_YES_NUM.bjGet(
                                      !!scope.row.giftFlag
                                    )
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "stockWarehouseCode",
                    label: _vm.$t("SourcingDetails.form.warehouse"),
                    width: "212",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "stockWarehouseName",
                    label: _vm.$t("SourcingDetails.form.Shipment"),
                    width: "212",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "failReason",
                    label: _vm.$t("SourcingDetails.form.Failure"),
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }